"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var PayrollLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(PayrollLineResource, _super);
    function PayrollLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PayrollLineResource, "related", {
        get: function () {
            return Object.assign({}, lines_1.BaseLineResource.related, {
                referencing_line: PayrollLineResource,
            });
        },
        enumerable: true,
        configurable: true
    });
    PayrollLineResource.endpoint = '/lines/pr';
    PayrollLineResource.MODEL_NAME = 'payrollline';
    return PayrollLineResource;
}(lines_1.BaseLineResource));
exports.default = PayrollLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/pr/lines.js
// module id = XiTZ
// module chunks = 0